import { getAuthIdentityEpoch, onAuthIdentityChange } from "./authTokenStore.js";

// Page-session history retains the original input so evidence links keep their provenance.
const MAX_REVIEWS = 20;
let entries = [];
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());
export const subscribeReviewHistory = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const getReviewHistory = () => entries;
export function clearReviewHistory() { entries = []; notify(); }
onAuthIdentityChange(clearReviewHistory);
export function rememberReview({ historyKey, scopeKey, input, result, selectionDescription, epoch }) {
    if (epoch !== getAuthIdentityEpoch() || result.status !== "done") return;
    if (result.cached && entries.some((entry) => entry.historyKey === historyKey && entry.result.report === result.report)) return;
    entries = [{ id: crypto.randomUUID(), historyKey, scopeKey, input, result, selectionDescription, completedAt: result.completedAt || Date.now() }, ...entries].slice(0, MAX_REVIEWS);
    notify();
}
